/* eslint-disable no-console */
import { Box, FormControl } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';
import { FieldSelector, mapFieldType } from './FieldSelector';

export const DirectInsertConfigEditor = ({
  availableFields,
  value,
  onChange,
}: {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeDirectInsertConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.DeclarativeDirectInsertConfig,
  ) => void;
}) => {
  console.log(onChange, value);

  const setField = (field: string) => {
    const type = mapFieldType(field, availableFields);
    finleyAssert(type === 'number', 'only number type is supported');
    onChange({
      ...value,
      config: {
        ...value.config,
        kickoutValueField: field,
      },
    });
  };

  return (
    <Box p={1}>
      <FormControl>
        <ConcentrationCalcFieldLabel
          m={1}
          label="Kickout Value Field"
          tooltip="This field's value will be used as kickout."
        />
        <FieldSelector
          availableFields={availableFields}
          allowedTypes={['float', 'integer']}
          initialField={value.config.kickoutValueField}
          onSelectedFieldChange={(field) => setField(field)}
        />
      </FormControl>
    </Box>
  );
};
